import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import Login from './pages/Login'
import SelectSchool from './pages/SelectSchool'
import Scanner from './pages/Scanner'

function Protected({ children }) {
  const { session, loading } = useAuth()
  if (loading) return <div style={{ textAlign: 'center', margin: '2rem' }}>جاري التحميل...</div>
  if (!session) return <Navigate to="/login" replace />
  return children
}

function RequireSchool({ children }) {
  const { activeSchoolId, allowedSchools, loading } = useAuth()
  if (loading) return <div style={{ textAlign: 'center', margin: '2rem' }}>جاري التحميل...</div>

  if (!allowedSchools?.length) {
    return (
      <div dir="rtl" style={{ maxWidth: 520, margin: '2rem auto', padding: 16 }}>
        <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', padding: 12, borderRadius: 10 }}>
          لا توجد مدارس مرتبطة بهذا الحساب.
        </div>
      </div>
    )
  }

  if (!activeSchoolId) return <Navigate to="/select-school" replace />
  return children
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/select-school"
          element={(
            <Protected>
              <SelectSchool />
            </Protected>
          )}
        />
        <Route
          path="/"
          element={(
            <Protected>
              <RequireSchool>
                <Scanner />
              </RequireSchool>
            </Protected>
          )}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}
